import React, { useState, useEffect } from 'react';
import ParadiseMudNavbar from 'paradise-mud-navbar';
import Modal from 'react-modal';
import GeneralLoginForm from '@/components/general/Forms/GeneralLoginForm/GeneralLoginForm';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import ParadiseNavbarContent from './ParadiseNavbarContent';
import { setLenguageData } from '@/redux/actions/lenguageDataActions';
import { NewHeaderModal } from '@/components/general/Header/modal/NewHeaderModal';
import { setCurrency } from '@/redux/actions/currencyActions';
import 'paradise-mud-navbar/src/components/ParadiseMudNavbar.css';
import '../PersonalizedHeaderStyles.scss';

const Header = props => {
  const dispatch = useDispatch();
  const lenguageData = useSelector(state => state.lenguage.lang);
  const currencyData = useSelector(state => state.currency.currency);
  const user = useSelector(state => state.user);

  const [scrollPosition, setScrollPosition] = useState(0);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [lenguageFlow, setLenguageFlow] = useState(false);
  const [currencyFlow, setCurrencyFlow] = useState(false);
  const [NewHeaderModalOpen, setNewHeaderModalOpen] = useState(false);
  const [testSwitch, setTestSwitch] = useState(true);
  const [values, setValues] = useState({
    location: '',
    startDate: '',
  });

  const setFieldValue = (field, value) => {
    setValues(prev => ({ ...prev, [field]: value }));
  };

  const staticLocationsFromSearch = [
    {
      place_id: '1',
      description: 'Mexico city',
      description_en: 'Ciudad de México',
      icon: '/path/to/icon.png',
    },
  ];

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const [selectedSuggestionxCBO, setSelectedSuggestionxCBO] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const isSearchPage =
    location.pathname === '/search' || location.pathname === '/busqueda';

  const openNewHeaderModal = () => {
    hideMobileMenu();
    setNewHeaderModalOpen(true);
  };

  const closeNewHeaderModal = () => setNewHeaderModalOpen(false);

  const turnOnMobileLanguageFlow = () => setLenguageFlow(true);
  const turnOffMobileLanguageFlow = () => setLenguageFlow(false);
  const turnOnMobileCurrencyFlow = () => setCurrencyFlow(true);
  const turnOffMobileCurrencyFlow = () => setCurrencyFlow(false);

  const hideMobileMenu = () => {
    const modal = document.querySelector(
      '.paradise-mud-mobile-navbar-modal.visible',
    );
    if (modal) modal.classList.remove('visible');
  };

  const changueLang = () => {
    dispatch(
      setLenguageData({
        lang: lenguageData === 'EN' ? 'ES' : 'EN',
        isButton: true,
      }),
    );
  };

  const changueCurrency = () => {
    dispatch(
      setCurrency({
        currency: currencyData === 'USD' ? 'MXN' : 'USD',
        isButton: true,
      }),
    );
  };

  const goToHome = () => {
    hideMobileMenu();
    navigate('/');
  };

  const goToSpaces = () => {
    hideMobileMenu();
    navigate('/stillBuilding');
  };

  const goToBlog = () => {
    hideMobileMenu();
    navigate('/stillBuilding');
  };

  const closeModal = () => setIsOpen(false);

  const routesWithoutHeaderOptions = [
    '/paseDeCoworkingPolanco',
    '/dayPassCoworkingPolanco',
    '/paseDeCoworkingCondesa',
    '/dayPassCoworkingCondesa',
    '/salaDeJuntasPolanco',
    '/meetingRoomPolanco',
  ];

  const effectOnScroll = location.pathname === '/';
  const hideHeaderOptions = routesWithoutHeaderOptions?.includes(
    location.pathname,
  );

  useEffect(() => {
    const handleScroll = () => setScrollPosition(window.pageYOffset);
    window.addEventListener('scroll', handleScroll);

    const handleHamburgerClick = e => {
      const svgIcon = e.target.closest('.paradise-mud-mobile-navbar-hamburger');
      if (svgIcon) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        openNewHeaderModal();
      }
    };

    window.addEventListener('click', handleHamburgerClick, true);

    // SOLUCIÓN: Detectar clicks en el logo o su contenedor
    const handleLogoClick = e => {
      // Verificar si el click fue en el logo o sus contenedores
      const isLogo =
        e.target.closest('.paradise-mud-navbar-logo-img') ||
        e.target.closest('.paradise-mud-navbar-logo') ||
        e.target.closest('.logo-container') ||
        e.target.closest('[class*="logo-container"]') ||
        e.target.closest('[class*="navbar-logo"]') ||
        e.target.closest('img[alt="logo"]') ||
        e.target.closest('img[src*="Logo"]') ||
        e.target.closest('img[src*="P_Blanco"]');

      if (isLogo) {
        e.preventDefault();
        e.stopPropagation();
        goToHome();
      }
    };

    // Agregar el listener al documento (siempre funcionará)
    document.addEventListener('click', handleLogoClick, true);

    // También intentar adjuntar evento directamente al logo
    const attachDirectEvent = () => {
      const logo = document.querySelector(
        '.paradise-mud-navbar-logo-img, .paradise-mud-navbar-logo, .logo-container, img[alt="logo"]',
      );
      if (logo) {
        logo.style.cursor = 'pointer';
        logo.removeEventListener('click', goToHome);
        logo.addEventListener('click', goToHome);
      }
    };

    attachDirectEvent();

    // Observer para cuando se re-renderice
    const observer = new MutationObserver(attachDirectEvent);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('click', handleHamburgerClick, true);
      document.removeEventListener('click', handleLogoClick, true);
      observer.disconnect();

      const logo = document.querySelector(
        '.paradise-mud-navbar-logo-img, .paradise-mud-navbar-logo, .logo-container',
      );
      if (logo) logo.removeEventListener('click', goToHome);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const navBarStyleConditions = scrollPosition > 280 || !effectOnScroll;
  const navbarMainLogo = '/Logotipo_Popnest.png';
  const navbarMainLogoBlanco = '/Logotipo_P_Blanco.png';

  const mobileNavBarLinks = () => {
    if (hideHeaderOptions) return [];

    if (lenguageFlow) {
      return [
        {
          title: lenguageData === 'ES' ? '<- Atrás' : '<- Back',
          onClick: turnOffMobileLanguageFlow,
        },
        {
          title: '🇲🇽 Español (México)',
          onClick: () =>
            dispatch(setLenguageData({ lang: 'ES', isButton: true })),
        },
        {
          title: '🇺🇸 English (United States)',
          onClick: () =>
            dispatch(setLenguageData({ lang: 'EN', isButton: true })),
        },
      ];
    }

    if (currencyFlow) {
      return [
        {
          title: lenguageData === 'ES' ? '<- Atrás' : '<- Back',
          onClick: turnOffMobileCurrencyFlow,
        },
        {
          title: 'MXN - Peso Mexicano ($)',
          onClick: () =>
            dispatch(setCurrency({ currency: 'MXN', isButton: true })),
        },
        {
          title: 'USD - Dólar Estadounidense ($)',
          onClick: () =>
            dispatch(setCurrency({ currency: 'USD', isButton: true })),
        },
      ];
    }

    return [
      { title: lenguageData === 'ES' ? 'INICIO' : 'HOME', onClick: goToHome },
      {
        title: lenguageData === 'ES' ? 'ESPACIOS' : 'PLACES',
        onClick: goToSpaces,
      },
      { title: 'BLOG', onClick: goToBlog },
      {
        title: currencyData === 'MXN' ? '💲 MXN' : '💲 USD',
        onClick: turnOnMobileCurrencyFlow,
      },
      {
        title: testSwitch ? '🧪 Test ON' : '🧪 Test OFF',
        onClick: () => setTestSwitch(!testSwitch),
      },
    ];
  };

  return (
    <FlexContainer
      className={
        hideHeaderOptions
          ? 'flex-column myMainNavBarHideToogle'
          : 'flex-column myMainNavBar'
      }
    >
      {!isMobile && (
        <FlexContainer className="headerWrapper">
          <ParadiseMudNavbar
            navbarClassNames={['m-hide']}
            navbarLogos={[navbarMainLogoBlanco]}
          />

          <div className="searchOverlay">
            <ParadiseNavbarContent
              lenguageData={lenguageData}
              values={values}
              setFieldValue={setFieldValue}
              staticLocationsFromSearch={staticLocationsFromSearch}
              setSelectedSuggestionxCBO={setSelectedSuggestionxCBO}
              isMobile={isMobile}
              isSearchPage={isSearchPage}
            />
          </div>
        </FlexContainer>
      )}

      {isMobile && (
        <ParadiseMudNavbar
          navbarClassNames={['block-navbar']}
          navbarLogos={[navbarMainLogo]}
          navbarLinks={mobileNavBarLinks()}
          linksPosition="left"
        />
      )}
      <NewHeaderModal
        isOpen={NewHeaderModalOpen}
        onClose={closeNewHeaderModal}
        languageData={lenguageData}
      />

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Login Modal"
      >
        <GeneralLoginForm
          inputValue=""
          onRequestClose={closeModal}
          className="marglr40 m-marglr20 margt40"
        />
      </Modal>
    </FlexContainer>
  );
};

export default Header;
